export const introduce = {
  text: `### 指标原理
  + 处于盈利状态的代币供应量`,
  height: 1290,
};